import React from 'react';
import PropTypes from 'prop-types';
import { MuiThemeProvider, ThemeProvider } from '@material-ui/core/styles';
import { materialTableTheme } from '../utils/smartutils';

const MaterialTableThemeProvider = ({ children }) => {
  return (
    <MuiThemeProvider>
      <ThemeProvider theme={materialTableTheme}>{children}</ThemeProvider>
    </MuiThemeProvider>
  );
};

MaterialTableThemeProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default MaterialTableThemeProvider;
